import React from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import '../../shared/ReactSelectDarkMode.css';

/** Shared async-creatable select with the project's consistent CSS hooks. */
export default function AppAsyncCreatableSelect({
  className = 'react-select-container',
  classNamePrefix = 'react-select',
  ...props
}) {
  return <AsyncCreatableSelect className={className} classNamePrefix={classNamePrefix} {...props} />;
}
